import { css } from '@emotion/css';

import { LARGE_DEVICE_MQ, Spacing } from 'apps/shared/scripts/styles/constants';

export const layoutClassName = css({
  display: 'flex',
  [LARGE_DEVICE_MQ]: {
    height: '100vh',
  },
});

export const leftPanelClassName = css({
  height: '100%',
  width: '100%',
  [LARGE_DEVICE_MQ]: {
    overflow: 'auto',
    width: '42%',
  },
});

export const mainContentClassName = css({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  paddingLeft: Spacing.LG,
  paddingRight: Spacing.LG,
  [LARGE_DEVICE_MQ]: {
    paddingLeft: 64,
    paddingRight: 64,
  },
});

export const rightPanelClassName = css({
  background: '#fafafa',
  display: 'none',
  height: '100%',
  [LARGE_DEVICE_MQ]: {
    display: 'flex',
    flex: 1,
    width: 'auto',
  },
});
